<script setup lang="ts">
import type { ItpDataGridColumn } from './types';
import { columnKey, alignClass } from './gridCell';

withDefaults(
  defineProps<{
    columns: ItpDataGridColumn[];
    gridTemplateColumns: string;
    columnTotals: Record<string, number>;
    formatTotal: (column: ItpDataGridColumn, value: number) => string;
    fromSelection?: boolean;
    selectedCount?: number;
    hasSystemColumn?: boolean;
  }>(),
  { fromSelection: false, selectedCount: 0, hasSystemColumn: false },
);
</script>

<template>
  <div
    class="itp-data-grid__footer"
    :class="{ 'from-selection': fromSelection }"
    :style="{ gridTemplateColumns }"
  >
    <div
      v-if="hasSystemColumn"
      class="itp-data-grid__fcell itp-data-grid__syscell"
    >
      <span v-if="fromSelection" class="itp-data-grid__selcount">{{
        selectedCount
      }}</span>
      <span v-else class="itp-data-grid__sigma">Σ</span>
    </div>
    <div
      v-for="column in columns"
      :key="columnKey(column)"
      class="itp-data-grid__fcell"
      :class="alignClass(column)"
    >
      <span
        v-if="columnKey(column) in columnTotals"
        class="itp-data-grid__text"
        >{{ formatTotal(column, columnTotals[columnKey(column)]) }}</span
      >
    </div>
  </div>
</template>
